import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

/**
 * Get a predicate element from store by ID
 * @param {string} id
 * @returns object | null
 */
export const useCriteriaStorePredicates = (ids = []) => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);

    return ids.map((id) => predicates?.[id]);
};
